'use client';
import { ChangeEvent, FormEvent } from 'react';
import { IcCircleCancelFill, theme } from '@bgzt/ui';
import { Input } from '~/components';

import styles from './SearchForm.module.css';

type Props = {
  value: string;
  onChange?(value: string): void;
  onSubmit?(value: string): void;
  onFocus?(): void;
  onClick?(): void;
  readOnly?: boolean;
  allowClear?: boolean;
  placeholder?: string;
};

const SEARCH_INPUT = {
  NAME: 'search-input',
  MAX_LENGTH: 40,
};

export const SearchForm = ({
  value,
  onChange,
  onSubmit,
  onFocus,
  onClick,
  placeholder = '한글/일본어로 상품을 검색해 보세요',
  readOnly = false,
  allowClear = false,
}: Props) => {
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const searchInputElement = event.currentTarget.elements.namedItem(SEARCH_INPUT.NAME) as HTMLInputElement;
    const searchValue = searchInputElement.value;

    if (!searchValue) return;

    onSubmit?.(searchValue);
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange?.(event.target.value);
  };

  const handleClickRemove = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onChange?.('');
  };

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <Input
        type="search"
        className={styles.input}
        name={SEARCH_INPUT.NAME}
        maxLength={SEARCH_INPUT.MAX_LENGTH}
        value={value}
        onClick={onClick}
        onFocus={onFocus}
        readOnly={readOnly}
        onChange={handleChange}
        placeholder={placeholder}
        enterKeyHint="search"
      />

      {allowClear && value && (
        <button type="button" className={styles.removeButton} onClick={handleClickRemove}>
          <IcCircleCancelFill fill={theme.colors['gray-150']} size={16} />
        </button>
      )}
    </form>
  );
};
